import { useState } from "react";
import Category from "../../components/category";
import DivStyle from "../../components/style/div.component";
import HoldemNow from "../../components/holdemNowMessage/holdemNow";
import HoldemNowUpload from "../../components/holdemNowMessage/holdemNowUpload";
import HoldemNowUpdate from "../../components/holdemNowMessage/holdemNowUpdate";
import HoldemNowLog from "../../components/holdemNowMessage/holdemNowLog";

const HoldemNowMessage = () => {
  const [selectTab, setSelectTab] = useState(0);
  const tabs = [
    {
      text: "홀덤 NOW 등록 현황",
      value: 0,
    },
    {
      text: "홀덤 NOW 수동 등록",
      value: 1,
    },
    {
      text: "홀덤 NOW 삭제",
      value: 2,
    },
    {
      text: "홀덤 NOW 로그",
      value: 3,
    },
  ];
  return (
    <DivStyle
      style={{ overflow: "auto" }}
      width="100%"
      height="100vh"
      backgroundColor="#121212"
      display="flex"
      flex_direction="column"
      marginTop="65px"
      setMobile={true}
      align_items="center"
      marginBottom="40px"
    >
      <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
        홀덤 NOW 및 가맹점 포인트
      </h2>
      <Category tabs={tabs} selectTab={selectTab} setSelectTab={setSelectTab} />
      {selectTab === 0 && <HoldemNow />}
      {selectTab === 1 && <HoldemNowUpload />}
      {selectTab === 2 && <HoldemNowUpdate />}
      {selectTab === 3 && <HoldemNowLog />}
    </DivStyle>
  );
};

export default HoldemNowMessage;
